import React from 'react';

export type Props = {
    size: string;
};

export const DisplayIcon = ({ size }: Props) =>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        preserveAspectRatio="xMidYMid meet"
        viewBox="0 0 600 400"
        className={ `device-class-icon ${size}` }
    >
        <path
            d="M583.91 6.02C590.72 6.02 596.25 11.54 596.25 18.36C596.25 94.29 596.25 309.74 596.25 385.67C596.25 392.49 590.72 398.02 583.91 398.02C467.88 398.02 132.12 398.02 16.09 398.02C9.28 398.02 3.75 392.49 3.75 385.67C3.75 309.74 3.75 94.29 3.75 18.36C3.75 11.54 9.28 6.02 16.09 6.02C132.12 6.02 467.88 6.02 583.91 6.2Z" id="i47z0PGmVq"
            fill="#ffffff" fillOpacity="1" stroke="#000000" strokeWidth="8" strokeOpacity="1"
        />
        <text
            id="c2hgM2wAaA"
            x="350"
            y="290"
            fontSize="250"
            fontFamily="Open Sans"
            fontWeight="normal"
            fontStyle="normal"
            letterSpacing="0"
            alignmentBaseline="before-edge"
            transform="matrix(1 0 0 1 38 -182.99999999999994)"
            style={ { lineHeight: "100%" } }
            xmlSpace="preserve"
            dominantBaseline="text-before-edge"
            fill="#000000"
            fillOpacity="1"
        >
            <tspan x="370" dy="0em" alignmentBaseline="before-edge" dominantBaseline="text-before-edge" textAnchor="start">L</tspan>
        </text>
        <path
            d="M509.93 79.5L536.08 115.68L483.77 115.68L431.47 115.68L457.62 79.5L483.77 43.32L509.93 79.5Z"
            fill="#0e0e0e" fillOpacity="1"
        />
        <path
            d="M35.79 37.67L373.12 37.67L373.12 366.36L35.79 366.36L35.79 37.67Z"
            fill="#d7d7d7" fillOpacity="1"
        />
    </svg>
;
